import { useContentTypeReportes } from './useReportes.hook'

//components
import NavBar from './NavBar'
import Layout from '../../components/layouts/index'
import ListBalanceGeneral from './balanceGeneral/ListBalanceGeneral'
import ListLibroDiario from './libroDiario/ListLibroDiario'
import ListLibroMayor from './libroMayor/ListLibroMayor'
import ListLibroAuxiliarProveedores from './libroAuxiliarProveedores/ListLibroAuxiliarProveedores'
import ListLibroAuxiliarCliente from './libroAuxiliarCliente/ListLibroAuxiliarCliente'
import ListEstadoDeResultados from './estadoDeResultado/ListEstadoDeResultados'
import ListEstadoDeResultadosExtend from './estadoDeResultadoExtendido/ListEstadoDeResultadosExtend'
import ListPorCobrar from './porCobrar/ListPorCobrar'
import ListPorPagar from './porPagar/ListPorPagar'
import ListConciliacion from './conciliaciones/ListConciliaciones'
import ListLibroBancoConciliaciones from './libroBancoConciliaciones/ListLibroBancoConciliaciones'
import { Button } from '@mui/material'
import { useMemo, useState } from 'react'
import ResizableModal from '../../components/modules/ui/ResizableModal'

const Informes = () => {
  const typeContent = useContentTypeReportes(state => state.typeContent)
  const [showModal, setShowModal] = useState(false)

  const renderContent = () => {
    switch (typeContent) {
      case '2':
        return <ListEstadoDeResultados />
      case '3':
        return <ListEstadoDeResultadosExtend />
      case '4':
        return <ListPorCobrar />
      case '5':
        return <ListBalanceGeneral />
      case '6':
        return <ListPorPagar />
      case '8':
        return <ListLibroAuxiliarCliente />
      case '9':
        return <ListLibroAuxiliarProveedores />
      case '10':
        return <ListConciliacion />
      case '11':
        return <ListLibroDiario />
      case '12':
        return <ListLibroMayor />
      case '13':
        return <ListLibroBancoConciliaciones />
      default:
        return <div />
    }
  }

  const content = useMemo(() => renderContent(), [typeContent])

  return (
    <Layout>
      <div>
        <NavBar setShowModal={setShowModal} />
        <ResizableModal
          open={showModal}
          onClose={e => {
            e.stopPropagation()
            setShowModal(false)
          }}
          height={800}
          footer={
            <>
              <Button
                variant='contained'
                sx={{
                  borderRadius: '50px',
                  backgroundColor: '#000033',
                  color: '#FFFFFF',
                  '&:hover': { backgroundColor: '#000033' }
                }}
                onClick={() => setShowModal(false)}
              >
                Cerrar
              </Button>
            </>
          }
        >
          <div className='flex h-full min-h-0 flex-col overflow-hidden p-6 font-sans'>
            {content}
          </div>
        </ResizableModal>
      </div>
    </Layout>
  )
}

export default Informes
